import { Reducer } from "redux";
import {
  PcpSelectionActions,
  SET_SELECTED_PCP_LINE,
  SET_SELECTED_PCP_ROW,
  PcpMode,
  SET_SELECTED_PCP_LINE_INDEX,
} from "./actions";

export type PcpSelectionState = {
  byMode: Record<
    PcpMode,
    { selectedLine: number | null; selectedRow: Record<string, any> | null }
  >;
};

const initial: PcpSelectionState = {
  byMode: {
    passive: { selectedLine: null, selectedRow: null },
    active: { selectedLine: null, selectedRow: null },
    offset: { selectedLine: null, selectedRow: null },
  },
};

//@ts-ignore
const reducer: Reducer<PcpSelectionState, PcpSelectionActions> = (
  state = initial,
  action
) => {
  switch (action.type) {
    case SET_SELECTED_PCP_LINE_INDEX:
      return {
        ...state,
        byMode: {
          ...state.byMode,
          [action.payload.mode]: {
            ...state.byMode[action.payload.mode],
            selectedLineIndex: action.payload.value ?? null,
          },
        },
      };
    case SET_SELECTED_PCP_LINE:
      return {
        ...state,
        byMode: {
          ...state.byMode,
          [action.payload.mode]: {
            ...state.byMode[action.payload.mode],
            selectedLine: action.payload.value ?? null,
          },
        },
      };
    case SET_SELECTED_PCP_ROW:
      return {
        ...state,
        byMode: {
          ...state.byMode,
          [action.payload.mode]: {
            ...state.byMode[action.payload.mode],
            selectedRow: action.payload.value ?? null,
          },
        },
      };
    default:
      return state;
  }
};

export default reducer;
